import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './analyticsExplore.jade';

export class AnalyticsExploreController {
  /* @ngInject */
  constructor($scope, $stateParams, $q, $filter, GamesResource, currentGame, GameAnalyticsResource, $state, toastr, $localStorage, ggTable, ggCSV) {
    this.$stateParams = $stateParams;
    this.$q = $q;
    this.apiDate = $filter('apiDate');
    this.translate = $filter('translate');
    this.format = $filter('format');
    this.GamesResource = GamesResource;
    this.currentGame = currentGame;
    this.GameAnalyticsResource = GameAnalyticsResource;
    this.query = new Rx.Subject();
    this.$state = $state;
    this.$localStorage = $localStorage;
    this.hideRightAxis = true;
    this.leftAxisSerieChange = new Rx.Subject();
    this.leftAxisSerieChange.subscribe((serie) => {
      if (serie.seriesName == 'installsConversionEvents') {
        this.hideRightAxis = true;
        delete this.series[1];
      } else {
        this.hideRightAxis = false;
      }
      this.updateGameAnalyticsQuery();
    });

    this.rightAxisSerieChange = new Rx.Subject();
    this.rightAxisSerieChange.subscribe((serie) => {
      this.updateGameAnalyticsQuery();
    });

    this.csv = new ggCSV();
    this.seriesTable = new ggTable({
      count: 50,
      counts: [10, 30, 50, 100],
      sorting: {date: 'asc'},
      enableCalculateTotals: true,
      csv: this.csv
    });

    this.availableSearchParams = [
      {key: "countryCode", name: "Country", placeholder: "Country..."},
      {key: "platform", name: "Platform", placeholder: "Platform..."},
      {key: "acquisitionSource", name: "Acquisition Source", placeholder: "Acquisition Source..."},
      {key: "paying", name: "Paying", placeholder: "Paying..."}
    ];

    this.installsConversionEventsKeysValues = {
      ALL: '30 days trend – Installs-to-Events - App',
      WITHOUT_REAPPI: 'Without ReAppi',
      REAPPI_ONLY: 'ReAppi Only'
    };

    this.installsConversionEventsUpliftKeysValues = {
      CONTROL: '30 days trend – Installs-to-Events - Control group',
      TREATMENT: '30 days trend – Installs-to-Events - Treatment group'
    };

    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);
    this.searchParams = {};
    this.series = [];
    this.exploreMetrics = [{
      metric: 'daily_app_conversion',
      format: 'percentage'
    }];
    this.seriesOptions = {
      new_players: {
        metric: 'new_players',
        type: 'area',
        bigLabel: 'sum',
        format: 'number'
      },
      dau: {
        metric: 'dau',
        type: 'spline',
        bigLabel: 'avg',
        format: 'number'
      },
      sessions_to_dau: {
        metric: 'sessions_to_dau',
        type: 'area',
        bigLabel: 'avg'
      },
      sessions: {
        metric: 'sessions',
        type: 'area',
        bigLabel: 'sum',
        format: 'number'
      },
      conversion_rate: {
        metric: 'conversion_rate',
        type: 'area',
        bigLabel: 'avg',
        format: 'percentage'
      },
      arp_dau: {
        metric: 'arp_dau',
        type: 'column',
        bigLabel: 'avg',
        format: (() => this.game.currency)
      },
      arp_pu: {
        metric: 'arp_pu',
        type: 'spline',
        bigLabel: 'avg',
        format: (() => this.game.currency)
      },
      transactions: {
        metric: 'transactions',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      revenue: {
        metric: 'revenue',
        type: 'spline',
        bigLabel: 'sum',
        format: (() => this.game.currency)
      },
      dpu: {
        metric: 'dpu',
        type: 'spline',
        bigLabel: 'avg',
        format: 'number'
      },
      conversions: {
        label: 'Conversions',
        metric: 'conversions',
        type: 'column',
        bigLabel: 'sum',
        format: 'number'
      },
      share_trend: {
        metric: 'share_trend',
        type: 'spline',
        bigLabel: 'avg',
        format: 'percentage'
      },
      installsConversionEvents: {
        label: this.translate('installsConversionEvents'),
        seriesName: 'installsConversionEvents',
        exploreMetrics: this.exploreMetrics,
        selectedExploreMetric: this.exploreMetrics[0],
        metric: 'daily_app_conversion',
        format: 'percentage',
        type: 'spline',
        areSeriesNotDateBased: true,
        forceSingleYAxis: true,
        noDateInTooltip: true,
        shouldExpendLegens: true,
        isXAxisCategory: true,
        hideRightAxis: true,
        queryParams: {cohort_request_type: 'REGULAR', cohort_request_mode: 'NULL_SEGMENT'},
        getData: ((params) => this.GameAnalyticsResource.one('cohort').get(params)),
        transformResponse: ((res) => this.installsConversionEventsTransformResponse(res, this.installsConversionEventsKeysValues))
      },
    };

    this.getGame($stateParams.gameId);

    //// TODO remove $watch after ng-change="vm.updateQuery()" is integrated into searchbox component
    let vm = this;
    $scope.$watch('vm.searchParams', function (newValue) {
      if (newValue) {
        vm.updateGameAnalyticsQuery();
      }
    }, true);
  }

  getAggregationType(metric) {
    switch(metric) {
      case 'daily_app_conversion':
      case 'ctr':
      case 'ecpc':
      case 'ecpa':
      case 'ecpm':
        return 'avg';
      default:
        return 'sum';
    }
  }

  segmentsTransformResponseTableData(res, conversionEventsKeysValues) {
    let tableCols = [
      {
        field: 'key',
        filter: {key: 'text'},
        sortable: 'key',
        title: 'Day',
        format: 'n/a',
        show: true
      }
    ]
    .concat(_.flatten(res.map(r =>
      [{
        field: r.data.key + '_app_conversions',
        filter: {key: 'text'},
        sortable: r.data.key + '_app_conversions',
        title: r.data.key === null ? 'Conversion Events' : (r.data.key + ' - Conversion Events'),
        format: 'number',
        show: true
      },
      {
        field: r.data.key + '_app_conversions_share',
        filter: {key: 'text'},
        sortable: r.data.key + '_app_conversions_share',
        title: r.data.key === null ? 'Share%' : (r.data.key + ' - Share%'),
        format: 'percentage',
        show: true
      },
      {
        field: r.data.key + '_acc_app_conversions_share',
        filter: {key: 'text'},
        sortable: r.data.key + '_acc_app_conversions_share',
        title: r.data.key === null ? 'Running total' : (r.data.key + ' - Running total'),
        format: 'percentage',
        show: true
      }]
    )));

    this.GameAnalyticsResource.one('cohort').one('explore').get(res[0].query)
      .then((response) => {
        let fields = _.chain(tableCols).map('field').value();

        let dataWithSegmentColumn = response.explore_data.map(r => {
          r.rows.map(row => {
            row[conversionEventsKeysValues[r.key] + '_app_conversions'] = row.app_conversions;
            row[conversionEventsKeysValues[r.key] + '_app_conversions_share'] = row.app_conversions_share;
            row[conversionEventsKeysValues[r.key] + '_acc_app_conversions_share'] = row.accumulated_app_conversions_share;
            delete row.app_conversions;
            delete row.app_conversions_share;
            delete row.accumulated_app_conversions_share;
            return row;
          });
          return r.rows;
        })
        let tableData = _.merge(...dataWithSegmentColumn).map(row => _.pick(row, fields));
        this.seriesTable.appendData(tableData);
      });

    res[0].tableCols = tableCols;
    res[0].tableData = [];
    res[0].csvData = [];
    return res;
  };

  sortBreakdownSeries(series) {
    let aggregationType = this.getAggregationType(_.get(series, '[0].query.metric'));
    return _.sortBy(series, (serie) => { return -serie.data.summary[aggregationType]; })
  }

  translateInstallsConversionEvents(conversionEventsKeysValues, data) {
    return ({
      key: conversionEventsKeysValues[data.key],
      rows: data.rows,
      summary: data.summary
    })
  }

  installsConversionEventsTransformResponse(series, conversionEventsKeysValues) {
    const transformed = _.map(series, (value) => ({data: this.translateInstallsConversionEvents(conversionEventsKeysValues, value.data), query: value.query}))
    let sorted = this.sortBreakdownSeries(transformed);
    return this.segmentsTransformResponseTableData(sorted, conversionEventsKeysValues);
  }

  segmentsTransformResponse(series) {
    let sorted = this.sortBreakdownSeries(series);
    return this.segmentsTransformResponseTableData(sorted);
  }

  getGame(id) {
    this.GamesResource.one(id).get()
      .then((res) => {
        this.game = res;
        this.game.getGameDeveloper()
          .then((gameDeveloper) => {
            this.game.currency = gameDeveloper.currency;
            this.currentGame.onNext(this.game);
            this.updateGameAnalyticsQuery();
          });
      })
  }

  updateGameAnalyticsQuery() {
    this.$localStorage.timeframe = this.timeframe;

    if (!this.game) {
      return;
    }

    let query = {
      game_id: this.game.id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),
      countryCode: this.searchParams.countryCode,
      platform: this.searchParams.platform,
      acquisitionSource: this.searchParams.acquisitionSource,
      paying: this.searchParams.paying,
      metric: _.chain(this.series).compact().map((s) => `${s.metric}_${s.type}`).join('+').value()
    };

    if (this.timeframe.comparisonStartDate && this.timeframe.comparisonEndDate) {
      query.comparison = {
        start_date: this.apiDate(this.timeframe.comparisonStartDate),
        end_date: this.apiDate(this.timeframe.comparisonEndDate)
      };
    }

    if (this.series.length) {
      this.$state.go('app.analytics.explore', {axisName: this.series[0].seriesName || this.series[0].metric}, {notify: false});
    }

    this.query.onNext(query);
  }
}

export function AnalyticsExploreComponent() {
  return {
    template,
    controller: AnalyticsExploreController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.analytics.explore', [
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
.directive('analyticsExplore', AnalyticsExploreComponent);



/** WEBPACK FOOTER **
 ** ./src/components/analytics/analyticsExplore.js
 **/